import React from "react";
import { Icon } from "../Icon/Icon";

export const Card = ({
  linkUrl,
  customClasses,
  iconName,
  title,
  subtitle,
  type,
  description,
  linkText,
  onLinkClick = () => {},
  linkTarget = "_self",
}) => {
  function renderContent() {
    const content = (
      <article className={["card", `--${type}`, customClasses].join(" ")}>
        <Icon setViewBox="yes" name={iconName} />
        {type !== "card-link" && title ? (
          <h3 className="title">{title}</h3>
        ) : (
          ""
        )}

        {
          type === "card-quote" ? <h4 className="subtitle">{subtitle}</h4> : ""
        }

        <footer>
          {
            type === "card-info" && subtitle ? (
              <h3 className="subtitle">{subtitle}</h3>
            ) : (
              ""
            )
          }

          <p>{description}</p>
          
          {type === "card-link" ? (
            <span className="redBtnLink" role="link">
              {linkText}
              <Icon setViewBox="yes" name="chevron-right" />
            </span>
          ) : (
            ""
          )}
        </footer>
      </article>
    );

    return content;
  }
  return (
    <>
      {type === "card-link" ? (
        <a
          onClick={(evt) => {
            onLinkClick(evt);
          }}
          href={linkUrl}
          target={linkTarget}
        >
          {renderContent()}
        </a>
      ) : (
        renderContent()
      )}
    </>
  );
};
